// extracted by mini-css-extract-plugin
export var text = "_5o-0";